import EstablishmentContactForm from "./EstablishmentContactForm";

type ManagerFormProps = {
    goto: (step: number) => void;
    nextStep: number;
    profilId: string;
};

export default function EstablishmentManagerForm({
    goto,
    nextStep,
    profilId,
}: ManagerFormProps) {
    const title = "Coordonnées du dirigeant de l’établissement";
    const subTitle =
        "Renseignez les informations des personnes à contacter en cas de besoin";
    const jobTitle = "Le dirigeant";
    return (
        <EstablishmentContactForm
            goto={() => goto(nextStep)}
            nextStep={nextStep}
            profilId={profilId}
            title={title}
            subTitle={subTitle}
            jobTitle={jobTitle}
        />
    );
}
